import Swiper from "swiper";
import { Keyboard, Mousewheel, Navigation } from "swiper/modules";
import "swiper/css";

const initBuildProgressContentSliders = () => {
  document.querySelectorAll("[data-build-progress-content]").forEach((root) => {
    const sliderEl = root.querySelector(".build-progress-content__slider");
    if (!sliderEl) return;

    const prevEl = root.querySelector(".build-progress-content__btn--prev");
    const nextEl = root.querySelector(".build-progress-content__btn--next");

    new Swiper(sliderEl, {
      modules: [Keyboard, Mousewheel, Navigation],
      slidesPerView: 1,
      spaceBetween: 20,
      watchOverflow: true,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      mousewheel: {
        forceToAxis: true,
        sensitivity: 1,
      },
      navigation: {
        prevEl,
        nextEl,
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
        },
      },
    });
  });
};

export default initBuildProgressContentSliders;
